if((typeof Shopify) === 'undefined'){ window.Shopify = {}; }
if((typeof Shopify.getCart) === 'undefined'){
  Shopify.getCart = function(callback, cart){
    if(!cart){
      return jQuery.getJSON('/cart.js', function(cart, textStatus, xhr){
        if((typeof callback) === 'function'){
          callback(cart, textStatus, xhr);
        } else if(typeof Shopify.onCartUpdate === 'function'){
          Shopify.onCartUpdate(cart);
        }
      });
    } else {
      if((typeof callback) === 'function'){
        callback(cart);
      } else if(typeof Shopify.onCartUpdate === 'function'){
        Shopify.onCartUpdate(cart);
      }
    }
  };
}

/**
 * Product Form Components
 *
 */
class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

   if(window.innerWidth < 991){
    // this.form = this.querySelector('form.stickey-form');
    // this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
   }
    this.cartElement = document.querySelector('ajax-cart');

    this.qtyBtns = this.querySelectorAll('[data-qty-btn]');
    this.qtyBtns.forEach(qtyBtn => qtyBtn.addEventListener('click', this.manageQtyBtn.bind(this)));

    this.stickyBtn = this.querySelector('[data-stickyAddBtn]');
    if(this.stickyBtn) this.stickyBtn.addEventListener('click', this.addStickyBtnProduct.bind(this));
  }

  /**
   * Product Form Submit event
   *
   * @param {evt} Event instance
   */
  async onSubmitHandler(evt) {
    console.log('here here here')
    // console.log('data-current-inventory', document.querySelector('[data-current-inventory]'));
    
    evt.preventDefault();
    // restrict gift card purchase js
    if(giftCardRestrict.enable_restrict_gift_card_purchasing == true){
      const isgiftcard = JSON.parse(this.querySelector('[type="submit"]').getAttribute('isgiftcard'));
      let normal_product_popup = document.querySelector('[normal_product_popup]');
      let gift_product_popup = document.querySelector('[gift_product_popup]');
      let isgiftcardInCart = false;
      const getCartData = await this.getCart();
      if(getCartData.items.length > 0){
        getCartData.items.forEach((element) => {
          if(element.gift_card == true){
            isgiftcardInCart = true
          }
        })
      }
      if(isgiftcard == true && isgiftcardInCart == false && getCartData.items.length > 0 ){
        gift_product_popup.show();
        return false;
      }else if(isgiftcard == false && isgiftcardInCart == true && getCartData.items.length > 0){
        normal_product_popup.show();
        return false;
      }
    }
    // restrict gift card purchase js END
    const addItems = [];
    const addOnItems = [];
    const submitButton = this.querySelector('[type="submit"]');
    const qtyInput = this.querySelector('[data-qty-input]');
    const minQtyThreshold = 10
    const inventoryQty = parseInt(document.querySelector('[data-current-inventory]'));
    const pdpContainer = this.closest('.product-details-wrapper');
    if(pdpContainer){
      if(pdpContainer.querySelector(".rc_widget__option__plans__dropdown")){
        console.log(pdpContainer.querySelector(".rc_widget__option__plans__dropdown").value, "waahahahahah");
  
        var keys = []
            let key =  pdpContainer.querySelector(".customFormProduct").getAttribute("id");
            keys.push(key)
            let value = pdpContainer.querySelector(".rc_widget__option__plans__dropdown").value;
            keys.forEach(keyElement => {
                // let key = keyElement.getAttribute("id");
                // let value = keyElement.value;
                frequencySelector[keyElement] = value;
            });
            let frequencySelectorString = JSON.stringify(frequencySelector);
            localStorage.setItem('frequencySelector', frequencySelectorString);
      }
  
    }


    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    addItems.push(JSON.parse(serializeForm(this.form)))
    if(pdpContainer){
      console.log('first iffff' );
      
      let addOnItemsEle = pdpContainer.querySelectorAll('[data-addon-selection]:checked');
      addOnItemsEle.forEach((addOn)=>{
      console.log('in each' );

        if(addOn.disabled == false){
      console.log('in each ifff' );

          let addOnParent = addOn.closest('addons-form');
          let addOnJSON = {
            id: addOnParent.querySelector('.variant--id').value,
            quantity: addOnParent.querySelector('.product-quantity').value
          }
          addItems.push(addOnJSON);
        }
      });
    }
    console.log('inventoryQty', inventoryQty)
    // console.log('data-current-inventory', document.querySelector('[data-current-inventory]'));
    console.log(addItems, 'kajsdjasdkljakldjakdljaksdljaskdjaskdjaskjdskajdkasjdkasdjkasdjaksdjaksdjaskdjaklsdjaskdjkasdjkasdjaskdjaskdjaksdjaskdjaskdjaksdjakldjak');
    

    const body = JSON.stringify({
      items: addItems
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
      .then((response) => response.json())
      .then((parsedState) => {
        Shopify.getCart(function(cart){
          if(document.querySelector('#PopupModal-quickshop')){
            document.querySelector('#PopupModal-quickshop .close-quickshop').dispatchEvent(new Event('click'))
          }
          this.cartElement.getCartData('open_drawer');
          if(qtyInput) qtyInput.value = 1;
        }.bind(this));
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
        let submitButtonText = submitButton.querySelector('.add-text').innerText;
        submitButton.querySelector('.add-text').innerHTML = 'Added !';
        setTimeout(() => {
          submitButton.querySelector('.add-text').innerHTML = submitButtonText;
        }, 3000);
      });
  }

  /**
   * Product Form Quantity Input update action
   *
   * @param {event} Event instance
   */
  manageQtyBtn(event) {
    console.log('hereee');
    event.preventDefault();
    let currentTarget = event.currentTarget;
    let action = currentTarget.dataset.for || 'increase';
    let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
    let currentQty = parseInt($qtyInput.value) || 1;
    let finalQty = 1;

    if(action == 'decrease' && currentQty <= 1){
        return false;
    }else if(action == 'decrease'){
        finalQty = currentQty - 1;
    }else{
        finalQty = currentQty + 1;
    }

    $qtyInput.value = finalQty;
  }

  addStickyBtnProduct(event) {
    event.preventDefault();
    console.log('addStickyBtnProductaddStickyBtnProductaddStickyBtnProductaddStickyBtnProductaddStickyBtnProductaddStickyBtnProduct');
    
    let currentTarget = event.currentTarget;
    let productId = currentTarget.getAttribute("data-productId") || null;
    let quantity = document.querySelector('[data-stickybtn] [data-qty-input]').value || 1;

    currentTarget.classList.add('loading');
    currentTarget.setAttribute('disabled', true);

    const result = fetch("/cart/add.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify({
            id: parseInt(productId),
            quantity: quantity
        })
    }).then(response => {
      //Pintrest tracking on Add To Cart
          pintrk('track', 'addtocart', {
          value: 100,
          order_quantity: 1,
          currency: 'USD'
        });
      // End Pintrest

        document.querySelector('ajax-cart').getCartData('open_drawer');
        currentTarget.classList.remove('loading');
        currentTarget.removeAttribute('disabled');
        currentTarget.querySelector('.add-text').innerHTML = 'Added !';
        setTimeout(() => {
            currentTarget.querySelector('.add-text').innerHTML = 'Add to cart';
            document.querySelector('[data-stickybtn] [data-qty-input]').value = "1";
        }, 3000);
    })
  }

  async getCart() {
    const result = await fetch("/cart.json");

    if (result.status === 200) {
        return result.json();
    }

    throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`);
  }
}
customElements.define('product-form', ProductForm);




class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form') || this.closest('.form-element');
    this.formType = this.form.dataset.format;
    this.addBtn = this.form.querySelector('[name="add"]');
    this.variant_json = this.form.querySelector('[data-variantJSON]');
    this.variantPicker = this.dataset.type;

    if(this.formType == 'product-page') this.onVariantChange('load');
    this.addEventListener('change', this.onVariantChange.bind(this));
  }

  onVariantChange(event) {
    console.log('variant changeddddd');
    
    this.setCurrentVariant();
    if(this.formType == 'product-page') window.globalVariables.product.currentVariant = this.currentVariant;

    if (!this.currentVariant) {
      this.toggleAddButton('disable');
      // Variant name update
      let options = this.form.querySelectorAll('[data-optionindex]');
      options.forEach(option => {
        let lableID = 'option'+option.dataset.optionindex;
        const selectedValue = option.querySelector('input[type="radio"]:checked');
        const lable = option.querySelector('.selected-option');
        if(!lable || !lableID || !selectedValue) return;
        lable.innerHTML = selectedValue.value;
      });
    } else {
      if(this.formType == 'grid'){
        const productGrid = this.closest('[data-product-grid]');
        this.renderProductInfo(this.currentVariant, productGrid);
        this._updateLinks(productGrid);
      }else{
        if(event){
          if(event == 'load'){
            templateProductJS?.prototype.manageVariantSlider(this.currentVariant);
          }else if(event){
            let currentTarget = event.target;
            let pdpContainer = currentTarget.closest('[data-product-container]');
            let quickShopModal = currentTarget.closest('#PopupModal-quickshop');
            let targetName = currentTarget.getAttribute('name') || '';
            targetName = targetName.toLowerCase();

            if(pdpContainer && (targetName.indexOf('color') > -1 || targetName.indexOf('options[color]') > -1)){
              if(quickShopModal){
                quickShop.prototype.manageVariantSlider(this.currentVariant);
              }else{
                templateProductJS?.prototype.manageVariantSlider(this.currentVariant);
              }
            }
          }
        }

        const productPage = this.closest('[data-product-container]');
        this.renderProductInfo(this.currentVariant, productPage);
      }
      this.updateURLandID(this.currentVariant);
      this.toggleAddButton('enable');
    }
  }

  _updateLinks(productGrid){
    if(!this.currentVariant || !productGrid) return;
    const variantURL = '?variant=' + this.currentVariant.id;
    const formLinks = productGrid.querySelectorAll('.product-link');
    formLinks.forEach(link => {
      let href = link.href.split('?')[0];
      link.href = href + variantURL;
    });
  }

  _getOptionsFromSelect() {
    let options = [];
    this.querySelectorAll('.variant_selector').forEach((selector)=>{
      options.push(selector.value);
    });
    return options;
  }

  _getOptionsFromRadio() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset:not(.addon-fieldset)'));
    const options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input:not(.addon-swatch)')).find((radio) => radio.checked).value;
    });
    return options;
  }

  setCurrentVariant() {
    // get all current values from selectors
    this.currentVariant = false;
    let options = (this.variantPicker == 'variant-select') ? this._getOptionsFromSelect() : this._getOptionsFromRadio();

    let variantsArray = this._getVariantData();
    variantsArray.find((variant) => {
      // get true or false based on options value presented in variant
      // value format would be [true/false,true/fasle,true/false] boolean value based on options present or not
      let mappedValues = variant.options.map((option, index) => {
        return options[index] === option;
      });

      // assign variant details to this.currentVariant if all options are present
      if(!mappedValues.includes(false)){
        this.currentVariant = variant;
        return;
      }
    });
  }

  updateURLandID(currentVariant) {
    if (!currentVariant) return;

    // update query string with latest variant ID
    if(this.formType == 'product-page') window.history.replaceState({ }, '', `${this.dataset.url}?variant=${currentVariant.id}`);

    // update variant input with currentVariant Id
    const input = this.form.querySelector('input[name="id"]');
    input.value = currentVariant.id;
  }

  renderProductInfo(currentVariant, container) {
    if(!currentVariant || !container) return;

    // Price Update
    let price = Shopify.formatMoney(currentVariant.price, window.globalVariables.money_format);
    let compare_price = Shopify.formatMoney(currentVariant.compare_at_price, window.globalVariables.money_format);
    let priceElement = container.querySelector('[data-currentPrice]');
    let comparePriceElement = container.querySelector('[data-comparePrice]');

    if(priceElement) priceElement.innerHTML = price;
    if(comparePriceElement) {
      comparePriceElement.innerHTML = compare_price;
      if(currentVariant.compare_at_price <= 0){
        comparePriceElement.style.display = 'none';
      }else{
        comparePriceElement.style.display = 'block';
      }
    }

    // Grid Image Update on variant selection
    if(this.formType == 'grid'){
      if(!currentVariant.featured_image) return;
      const featuredImage = container.querySelector('[data-feauredImage]');
      let updatedSrc = currentVariant.featured_image.src;
      if(updatedSrc){
        featuredImage.src = updatedSrc;
        featuredImage.srcset = updatedSrc;
      }
    }else{
      if(!currentVariant.featured_image) return;
      let imageID = currentVariant.featured_media.id;
      let imageSlide = document.querySelector(`.product--media[data-mediaID="${imageID}"]`);
      if(this.formType == 'quickshop'){
        imageSlide = document.querySelector(`.quickshop-slider .product--media[data-mediaID="${imageID}"]`);
      }
      if(!imageSlide) return;
      let slideIndex = Array.from(imageSlide.parentNode.children).indexOf(imageSlide);
      if(quickShopSlider) quickShopSlider.slideTo(slideIndex, 2000, true);
      else if(productSlider)  productSlider.slideTo(slideIndex, 2000, true);
    }

    // Variant name update
    let options = this.form.querySelectorAll('[data-optionindex]');
    options.forEach(option => {
      let lableID = 'option'+option.dataset.optionindex;
      const lable = option.querySelector('.selected-option');
      if(!lable || !lableID) return;
      lable.innerHTML = currentVariant[lableID];
    });
  }

  toggleAddButton(status) {
    if (!this.addBtn) return;

    if (status == 'disable') {
      this.addBtn.setAttribute('disabled', true);
      if(this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.unavailable;
    } else if(this.currentVariant && !this.currentVariant.available) {
      this.addBtn.setAttribute('disabled', true);
      if(this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.soldOut;
    } else {
      this.addBtn.removeAttribute('disabled');
      if(this.form.classList.contains('cart-upsell-form')){
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.upsellAddText;
      }else{
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.addToCart;
      }
    };
  }

  _getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.variant_json.textContent);
    return this.variantData;
  }
}

  customElements.define('variant-selects', VariantSelects);

  class VariantRadios extends VariantSelects {
    constructor() {
      super();

      this.form = this.closest('form') || this.querySelector('.form-element');
      this.formType = this.form.dataset.format;

      const colorSwatchContainer = this.querySelector('.color-swatch');
      if(colorSwatchContainer){
        const colorSwatches = colorSwatchContainer.querySelectorAll('.swatch');
        colorSwatches.forEach(swatch => {
          let colorHandle = swatch.querySelector('input[type="radio"]').dataset.handle;
          let swatchStyle = Utility.getSwatchStyle(colorHandle);
          swatch.querySelector('.swatch-label').setAttribute('style', swatchStyle);
        });
      }
    }
  }
  customElements.define('variant-radios', VariantRadios);
